export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/arrow-down.c34f4aa7-41952a.svg";